import { useLocation, Navigate } from "react-router-dom";
import NewPassword from "./NewPassword/NewPassword";
import TempPassword from "./TempPassword/TempPassword";

const SetPasswordHandler: React.FC = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const p = searchParams.get("p");
  const t = searchParams.get("t");
  if (p === "2") {
    return <NewPassword token={t} />;
  } else if (p === "1") {
    return <TempPassword token={t} />;
  } else {
    return <Navigate to="/" />;
  }
};
export default SetPasswordHandler;